const { mergeMap } = require("rxjs/operators");
const { ofType } = require("redux-observable");

const { marketplace: marketplaceApi } = require("@doctoroncallcom/api");
const {
  GET_CATEGORY,
  GET_CATEGORY_PRODUCTS,
  GET_SUB_CATEGORY,
} = require("./constants");

const {
  CategoriesSuccess,
  CategoriesError,
  CategoryProductSuccess,
  CategoryProductError,
  getSubCategoriesSuccess,
  getSubCategoriesError,
} = require("./actions");

const getCategory = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(GET_CATEGORY),
    mergeMap((action) =>
      marketplaceApi.newCategories
        .getCategory(marketplace, {
          store_type: action.payload.storeType,
        })
        .then((response) => CategoriesSuccess(response.data))
        .catch((error) => CategoriesError(error))
    )
  );

const getSubCategories = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(GET_SUB_CATEGORY),
    mergeMap((action) =>
      marketplaceApi.newCategories
        .subCategory(marketplace, action.payload.categoryName)
        .then((response) => getSubCategoriesSuccess(response.data))
        .catch((error) => getSubCategoriesError(error))
    )
  );

const getCategoryProduct = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(GET_CATEGORY_PRODUCTS),
    mergeMap((action) =>
      marketplaceApi.newCategories
        .getCategoryProduct(marketplace, action.payload.categoryName)
        .then((response) => CategoryProductSuccess(response.data))
        .catch((error) => CategoryProductError(error))
    )
  );

module.exports = {
  getCategory,
  getCategoryProduct,
  getSubCategories,
};
